import React, { useState, useEffect } from 'react';
import { Container, Form, Row, Col, Button } from '@themesberg/react-bootstrap';
import ListTables from '../../shared/tables';
import { post } from '../../../services/back.service';

function FormClaims({ id }) {
  const [currentType, setcurrentType] = useState('');
  const [currentDate, setcurrentDate] = useState('');
  const [currentvalue, setcurrentvalue] = useState('');
  const [infoClaims, setinfoClaims] = useState([]);
  const [claimObservation, setclaimObservation] = useState('');
  const [msgButton, setMsgButton] = useState('Guardar Informacion')

  // const handleForm = ({ target }) => {
  //   const value = target.type === 'checkbox' ? target.checked : target.value;
  //   setInfoResult({ ...infoClaims, [target.name]: value });
  //   //generalUpdate(target.name, value);
  // };
  const saveForm = (e) => {
    infoClaims.push({
      type: currentType,
      date: currentDate,
      value: currentvalue,
    });
    setcurrentType('');
    setcurrentDate('');
    setcurrentvalue('');
    setinfoClaims([...infoClaims]);
    //generalUpdate('infoClaims', infoClaims);
    //generalUpdate('claimObservation', claimObservation);
  };

  const deleteItem = (idx) => {
    infoClaims.splice(idx, 1);
    setinfoClaims(infoClaims);
    //generalUpdate('infoClaims', infoClaims);
  };

  const deleteButton = (row) => {
    const idx = infoClaims.findIndex((e) => e.type === row.type && e.date === row.date && e.value === row.value)
    return (
      <Button
        title="Eliminar"
        text="Eliminar"
        variant="outline-danger"
        onClick={() => deleteItem(idx)}
      >Eliminar</Button>
    );
  };
  const sendInfo = async (event) => {
    event.preventDefault();
    const body = {
      header: { obs_inspection_claims: claimObservation },
      data: infoClaims
    };
    const respo = await post('/peritaje/modifyinspection/claims/' + id, body);
    if (respo.success) {
      setMsgButton('Actualizar')
    }
  };

  useEffect(() => {
    const initForm = async () => {
      const body = {};
      const respo = await post(
        '/peritaje/infodetailinspection/claims/' + id,
        body,
      );
      if (respo.success) {
        const { detail, header } = respo.data;
        setclaimObservation(header.claimObservation)
        setinfoClaims(detail);
      }
    };
    initForm();
  }, [id]);

  return (
    <Container>
      <Row className="mb-1">
        <Col>
          <h1 className="fw-bold">SINIESTROS</h1>
        </Col>
      </Row>
      <hr style={{ opacity: 0.1 }} />
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="currentType">Tipo Siniestro</Form.Label>
          <Form.Select
            name="currentType"
            value={currentType}
            onChange={(e) => setcurrentType(e.target.value)}
            aria-label="Default select example"
          >
            <option value="">Seleccione</option>
            <option value="PTD">PTD</option>
            <option value="PTH">PTH</option>
            <option value="PPD">PPD</option>
            <option value="PPH">PPH</option>
            <option value="RC">RC BIENES</option>
            <option value="OTR">OTROS</option>
          </Form.Select>
          <Form.Label htmlFor="date">Fecha</Form.Label>
          <Form.Control
            type="date"
            name="currentDate"
            value={currentDate}
            onChange={(e) => setcurrentDate(e.target.value)}
            required
          />
          <Form.Label htmlFor="solicitante">Valor</Form.Label>
          <Form.Control
            type="number"
            name="currentvalue"
            value={currentvalue}
            onChange={(e) => setcurrentvalue(e.target.value)}
            required
          />

          <Row className="my-3">
            <Col className="d-flex justify-content-end">
              <Button
                type="submit"
                variant="primary"
                onClick={(e) => saveForm(e)}
              >
                Agregar Siniestro
              </Button>
            </Col>
          </Row>
        </Col>
        <Col>
          <ListTables
            data={infoClaims}
            editar={deleteButton}
            messageWd={'Agrege un siniestro'}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Label htmlFor="claimObservation">Observacion Siniestro</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            name="claimObservation"
            value={claimObservation}
            onChange={(e) => setclaimObservation(e.target.value)}
          />
        </Col>
      </Row>
      <Row className="my-3">
        <Col className="d-flex justify-content-end">
          <Button type="button" variant="primary" onClick={sendInfo}>
            {msgButton}
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default FormClaims;
